import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const DisclaimerModal = ({ isOpen, isMobile, onModalClose, modalData }) => {
	const { title, body, intro } = modalData;

	const onHide = () => {
		onModalClose();
	};

	return (
		<Modal
			show={isOpen}
			onHide={onHide}
			className={`m-1 ${isMobile ? 'dock-right' : null}`}
		>
			<Modal.Header closeButton>
				{title ? <Modal.Title>{title}</Modal.Title> : <Modal.Title />}
			</Modal.Header>
			<Modal.Body className="text-justify">
				<p>
					<strong>{intro} </strong>
					{body}
				</p>
			</Modal.Body>
		</Modal>
	);
};

DisclaimerModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	isMobile: PropTypes.bool.isRequired,
	onModalClose: PropTypes.func.isRequired,
	modalData: PropTypes.shape({
		title: PropTypes.string.isRequired,
		body: PropTypes.string.isRequired,
		intro: PropTypes.string.isRequired
	})
};

export default DisclaimerModal;
